import { Helmet } from "react-helmet-async";
import { baseURL } from "~/lib/base";

export type OgImageProps = {
  image: {
    height: number;
    url: string;
    width: number;
  };
};

export default function OgImage({ image }: OgImageProps) {
  return (
    <Helmet>
      <meta content={`${baseURL}${image.url}`} property="og:image" />
      <meta content={image.height.toString()} property="og:image:height" />
      <meta content={image.width.toString()} property="og:image:width" />
      <meta content={`${baseURL}${image.url}`} name="twitter:image" />
    </Helmet>
  );
}
